<mat-toolbar class="sm">
  <a class="branding" routerLink="/home" title="Home" i18n-title="logo hover">
    @if (logo() === 'logo') {
      <img id="brand-logo" src="assets/brand-logo.png" alt="FluentStride" />
    } @else {
      <img id="brand-icon" src="assets/brand-icon.png" alt="FluentStride" />
    }
  </a>
  <span class="stretch"></span>
  @if (!bare()) {
    <div id="whoami">
      <span>{{ account.firstName[0] }}{{ account.lastName[0] }}</span>
    </div>
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <ng-template matMenuContent>
        <button mat-menu-item routerLink="/home">
          <span>Home</span>
        </button>
        <button mat-menu-item routerLink="/account">
          <span>Account</span>
        </button>
        <button mat-menu-item routerLink="/cohort">
          <span>Classes</span>
        </button>
        <button mat-menu-item (click)="signOut()">
          <mat-icon>logout</mat-icon>
          <span>{{ STR.BTN_SIGN_OUT }}</span>
        </button>
      </ng-template>
    </mat-menu>
  } @else if (exit()) {
    <button mat-icon-button (click)="signOut()" [title]="STR.BTN_SIGN_OUT">
      <mat-icon>logout</mat-icon>
    </button>
  }
</mat-toolbar>
<mat-toolbar class="lg">
  <a class="branding" routerLink="/home" title="Home" i18n-title="logo hover">
    @if (logo() === 'icon') {
      <img id="brand-icon" src="assets/brand-icon.png" alt="FluentStride" />
    } @else {
      <img id="brand-logo" src="assets/brand-logo.png" alt="FluentStride" />
    }
  </a>
  <span class="stretch"></span>
  @if (!bare()) {
    <div id="whoami">
      <span>{{ account.firstName[0] }}{{ account.lastName[0] }}</span>
      <span>{{ account.firstName }} {{ account.lastName }}</span>
    </div>
  }
  @if (exit()) {
    <button mat-icon-button (click)="signOut()" [title]="STR.BTN_SIGN_OUT">
      <mat-icon>logout</mat-icon>
    </button>
  }
</mat-toolbar>
